import { useEffect, useState } from 'react';
import { CodeSearchBar } from '../components/search/CodeSearchBar';
import { UploadCodeCard } from '../components/search/UploadCodeCard';
import { searchUploads } from '../services/adminService';

export const SearchPage = ({ onOpenUpload }) => {
  const [query, setQuery] = useState('');
  const [uploads, setUploads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [openingCode, setOpeningCode] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let active = true;
    setLoading(true);
    setError('');

    searchUploads(query)
      .then((results) => {
        if (active) {
          setUploads(results);
        }
      })
      .catch((searchError) => {
        if (active) {
          setError(searchError.message);
          setUploads([]);
        }
      })
      .finally(() => {
        if (active) {
          setLoading(false);
        }
      });

    return () => {
      active = false;
    };
  }, [query]);

  const handleOpenUpload = (code) => {
    setOpeningCode(code);
    onOpenUpload(code);
  };

  return (
    <div className="px-3 pb-3">
      <CodeSearchBar query={query} onChange={setQuery} />

      {loading && <SearchLoading />}
      {error && <div className="alert alert-danger mx-2">{error}</div>}

      <div className="row m-0 gap-3" id="loadCodes">
        {!loading && uploads.map((upload) => (
          <UploadCodeCard
            key={upload.code}
            loading={openingCode === upload.code}
            upload={upload}
            onOpenUpload={handleOpenUpload}
          />
        ))}
      </div>
    </div>
  );
}

const SearchLoading = () => (
  <div className="search-loading mx-2 p-4 text-center">
    <span className="spinner-border text-success mb-3" aria-hidden="true" />
    <p className="m-0">Loading upload codes...</p>
  </div>
);

